import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import ArrowRight from "../../../../_common/_icons/ArrowRight"
import NRTButton from "../../../../_common/_buttons/Button"

import ZoomIn from "../../../../_common/_icons/ZoomIn"
import ZoomOut from "../../../../_common/_icons/ZoomOut"

const ActionsEnum = {
    BACK: 1,
    NEXT: 2,
    INCREASE: 'increase',
    DECREASE: 'decrease',
}

const Pagination = (props) => {

    const {
        totalPages,
        currentPage,
        onPageChange,
        onScaleChange,
    } = props

    return (
        <div className="pdf-pagination">
            <nav>
                <ul className="paginator">
                    <li className='prev'>
                        <NRTButton onClick={() => onPageChange(ActionsEnum.BACK)}
                                   iconButton
                                   title={'Página anterior'}
                                   content={
                                       <ArrowRight transform={'rotate(180 0 0)'} />
                                   }
                        />
                    </li>
                    <li className="page-counter">
                        <h3>{currentPage || 1} / {totalPages}</h3>
                    </li>
                    <li className='next'>
                        <NRTButton onClick={() => onPageChange(ActionsEnum.NEXT)}
                                   iconButton
                                   title={'Próxima página'}
                                   content={
                                       <ArrowRight />
                                   }
                        />
                    </li>
                </ul>

                <ul className="scale-controls">
                    <li>
                        <NRTButton onClick={() => onScaleChange(ActionsEnum.INCREASE)}
                                   title={'Aumentar Zoom'}
                                   iconButton
                                   content={
                                       <ZoomIn />
                                   }
                        />
                    </li>
                    <li>
                        <NRTButton onClick={() => onScaleChange(ActionsEnum.DECREASE)}
                                   title={'Reduzir Zoom'}
                                   iconButton
                                   content={
                                       <ZoomOut />
                                   }
                        />
                    </li>
                </ul>

            </nav>
        </div>
    )
}

Pagination.propTypes = {
    onPageChange: PropTypes.func.isRequired,
    onScaleChange: PropTypes.func.isRequired,
}

Pagination.defaultProps = {}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/PDF/Pagination/index.js